import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Filter extends Component {
  state = {
    showAll: false,
    facetsToShow: 10,
  };


  showAll = (e) =>
    this.setState({
      ...this.state,
      showAll: true,
    });

  hideAll = (e) =>
    this.setState({
      ...this.state,
      showAll: false,
    });


  render() {
    const facets = this.props.facets;
    return (
      <Fragment>
        {facets && facets.data.length > 0 && (
          <h3 className="single-facet-title">{this.props.displayName}</h3>
        )}
        <div className="facet-links">
          {facets &&
            facets.data.length > 0 &&
            facets.data.map((fk) => {
              const isSelected = this.props.isFacetActive(this.props.field, fk.value);
              return (
                <div
                  key={fk.value}
                  className={`facet-link-single ${isSelected && "active"}`}
                >
                  <a
                    onClick={
                      isSelected
                        ? this.props.delFacet(this.props.field, fk.value)
                        : this.props.addFacet(this.props.field, fk.value)
                    }
                  >
                    {fk.value}
                    &nbsp; ({fk.count}) &nbsp;
                    {/** isSelected && <FontAwesomeIcon icon="times" color='red' /> **/}
                    {this.props.app === "OSS"
                      ? isSelected && <span className="clearLink">[Clear]</span>
                      : isSelected && (
                          <FontAwesomeIcon icon="times" color="#b41f28" />
                        )}
                  </a>
                </div>
              );
            })}
          <div className="show-hide-wrapper">
            {this.props.facets &&
              Object.keys(this.props.facets).length > this.state.facetsToShow &&
              !this.state.showAll && (
                <a onClick={this.showAll} className="show-hide-link">
                  More <FontAwesomeIcon icon="caret-down" />
                </a>
              )}
            {this.props.facets &&
              Object.keys(this.props.facets).length > this.state.facetsToShow &&
              this.state.showAll && (
                <a onClick={this.hideAll} className="show-hide-link">
                  Less <FontAwesomeIcon icon="caret-up" />
                </a>
              )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Filter;
